import React, { useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { CartContext } from "components/cart";
import classNames from "lib/classNames";
import Switch from "components/Switch";

window.preview_one_click_upsell = {}
const NewOneCheckUpSell = ({ one_check_up_sell, multi_one_check_upsell }) => {
	const {
		cart_settings: { theme, rtl, font, money_format },
		add_to_cart,
		update_cart_item,
		Utils,
		isPreview,
		preview_product,
		productNotAddedToCart,
		shopify_cart_items,
		AppLocalStorage
	} = useContext(CartContext);
	let {
		product,
		text,
		truncate = true,
		truncate_length = 25,
		is_ticked_by_default,
	} = one_check_up_sell;
	if (
		(!Object.keys(product || {}).length || (product && !product.id)) &&
		isPreview
	) {
		product = Utils.fakePreviewProducts("2.99", 1)[0];
	}
	const [checked, setChecked] = useState(!productNotAddedToCart(product));
	const [userUncheck, setUserUncheck] = useState(0);

	const variant = product?.variants?.find(
		({ id }) => id.toString() == product.variant_id.toString()
	);
	window.preview_one_click_upsell[`product_${product.id}`] = () => {
		if (!product.isExample) preview_product(product, false);
	};
	const must_truncated = (text) => text.length > truncate_length;
	const truncate_name = (text) =>
		truncate
			? `"${text.substring(0, truncate_length).trim()}${must_truncated(text) ? "..." : ""
			}"`
			: text;

	//TODO: remove {price} && {title} after updating old campaigns
	const { border, border_color, align, highlight } = multi_one_check_upsell
	const formattedText = () => {
		if (!product || !variant) return ""
		return text
			.replace(
				/{{price}}/g,
				Utils.formatMoney(
					parseFloat(variant.price) *
					100 *
					parseFloat(window.Shopify.currency.rate),
					money_format
				)
			)
			.replace(
				/{{title}}/g,
				`<b class='link' data-type="product_name" onclick='preview_one_click_upsell.product_${product.id}()' style="font-size:1em;cursor:pointer;color:${Utils.formatColor(
					highlight || theme.primary
				)}">${truncate_name(product.title)}</b>`
			)
			.replace(
				"{price}",
				Utils.formatMoney(parseFloat(variant.price) * 100, money_format)
			)
			.replace(
				"{title}",
				`<b class='link' data-type="product_name" onclick='preview_one_click_upsell.product_${product.id}()' style="font-size:1em;cursor:pointer;color:${Utils.formatColor(
					highlight || theme.primary
				)}">${truncate_name(product.title)}</b>`
			)
	}
	useEffect(() => {
		const product_is_not_added = productNotAddedToCart(product)
		const product_is_removed = AppLocalStorage.getItem(`one_tick_removed_${product.id}`);
		if (is_ticked_by_default) {
			if (isPreview) {
				setChecked(true);
			} else {
				if (userUncheck === 0) {
					setUserUncheck(1);
					if (product_is_not_added && !Boolean(product_is_removed)) {
						console.log("handleOneCheckClick");
						handleOneCheckClick();
					} else if (!product_is_not_added) {
						setChecked(true);
					}
				} else {
					setChecked(!product_is_not_added);
				}
			}
		} else {
			setChecked(!product_is_not_added);
		}
	}, [is_ticked_by_default, shopify_cart_items]);

	const handleOneCheckClick = () => {
		const newStatus = !checked;
		setChecked(newStatus);
		if (newStatus && productNotAddedToCart(product)) {
			add_to_cart({
				variant_id: product.variant_id,
				product_handle: product.handle,
				quantity: 1,
				product
			});
		}
		else {
			update_cart_item({ variant_id: product.variant_id, quantity: 0 });
			AppLocalStorage.setItem(`one_tick_removed_${product.id}`, true);
		}
	};
	const handleOnclick = ({ target }) => {
		const isSwitch = Utils.hasParentWithMatchingSelector(target, ".one-tick-switch")
		if (target?.dataset?.type === "product_name" || isSwitch) {
			return;
		}
		handleOneCheckClick()
	}

	if (!variant) return null;
	return (
		<div
			className={classNames(
				"rounded flex items-center space-x-1 cursor-pointer",
				{
					"border py-2 px-1": border,
					"py-1": !border,
					"justify-center": align === "center"
				}
			)}
			style={{ borderColor: Utils.formatColor(border_color) }}
			onClick={handleOnclick}
		>
			<Tick
				checked={checked}
				onChange={handleOneCheckClick}
				{...multi_one_check_upsell}
			/>
			<div dangerouslySetInnerHTML={{ __html: formattedText() }} />
		</div>
	);
};

NewOneCheckUpSell.propTypes = {};

export default NewOneCheckUpSell;

function Tick (props) {
	const { variant, switch_on, switch_off, border, checked, onChange, highlight } = props;
	const { Utils } = useContext(CartContext);
	switch (variant) {
		case "switch":
			return <Switch
				value={checked}
				onChange={onChange}
				className="one-tick-switch"
				width={33}
				height={15}
				handleDiameter={17}
				noText
				onColor={Utils.formatColorHex(switch_on)}
				offColor={Utils.formatColorHex(switch_off)}
			/>
		case "square":
			return <SquareCheckbox checked={checked} highlight={highlight} />
		case "circle":
			return <CircleCheckbox checked={checked} highlight={highlight} />
	}
}

function CircleCheckbox ({ highlight, checked }) {
	const { Utils, cart_settings: { theme } } = useContext(CartContext);
	return <div
		className={classNames(
			"w-4 h-4 rounded-full flex-shrink-0 border-2 flex-center",
		)}
		style={{
			color: Utils.formatColor(theme.background),
			borderColor: Utils.formatColor(highlight || theme.primary),
			background: checked ? Utils.formatColor(highlight || theme.primary) : undefined,
			width: "fit-content",
			height: "fit-content",
			padding: 2
		}}
	>
		<svg
			aria-hidden="true"
			focusable="false"
			data-icon="check"
			style={{ width: 10, height: 10 }}
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 512 512"
			className={classNames({ "opacity-0": !checked })}
		>
			<path
				fill="currentColor"
				d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
			></path>
		</svg>
	</div>
}
function SquareCheckbox ({ highlight, checked }) {
	const { Utils, cart_settings: { theme } } = useContext(CartContext);
	return <div
		className={classNames(
			"w-4 h-4 flex-shrink-0 rounded border-2 flex-center",
		)}
		style={{
			color: Utils.formatColor(theme.background),
			borderColor: Utils.formatColor(highlight || theme.primary),
			background: checked ? Utils.formatColor(highlight || theme.primary) : undefined,
			width: "fit-content",
			height: "fit-content",
			padding: 2
		}}
	>
		<svg
			aria-hidden="true"
			focusable="false"
			data-icon="check"
			style={{ width: 10, height: 10 }}
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 512 512"
			className={classNames({ "opacity-0": !checked })}
		>
			<path
				fill="currentColor"
				d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
			></path>
		</svg>
	</div>
}
